import { render, staticRenderFns } from "./imgMainHot.vue?vue&type=template&id=8ad77fb6&"
import script from "./imgMainHot.vue?vue&type=script&lang=js&"
export * from "./imgMainHot.vue?vue&type=script&lang=js&"
import style0 from "./imgMainHot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports